<template>
<div id="app">
    <router-view />
</div>
</template>

<script>
/* eslint-disable */
export default {
  data () {
    return {
    }
  },
    name: 'app'
};
</script>

<style>
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}


.change-option {
    /* Pick the app primary color */
    color: grey;
    text-decoration: none;
    font-size: 13px;
    letter-spacing: 2.0px;
}

.change-choice, .go-back {
    font-size: 12px !important;
    letter-spacing: 2.0px;
    text-decoration: none;
}

.change-choice::before, .go-back::before {
    content: "\2039";
    font-weight: 300;
    font-size: 17px;
    margin-right: 5px;
}


.show-more {
    /* background: #9f9ba0bf; */
    border-radius: 2px;
    border: solid 1px #9f9ba0bf;
    font-size: 11px;
    text-decoration: none;
    padding: 5px;
    color: #000000f0;
    text-align: center;
}


.show-more:hover
/* .show-more:focus */
{
	background: #9f9ba0bf;
	color: #5c595d;
}

.pointer {
    cursor: pointer;
}

.gray{
    color: gray !important;
}
.black{
    color: #000!important;
}
</style>
